import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import './banner-adfox.styl';
import adfox from 'scripts/adfox';
import appHelper from 'app/pages/app/app.helper';
import { appSizeType, appLocaleType } from 'app/pages/app/app.types';

import { bannersDisabled } from 'app/pages/app/components/banners/app.banners';

const propTypes = {
  appSize: appSizeType.isRequired,
  appLocale: appLocaleType.isRequired,
  currentPath: PropTypes.string.isRequired,
};

const BannerAdfox = ({ appSize, appLocale, currentPath }) => {
  const platform = appHelper.isDesktopSize(appSize) ? 'desktop' : 'phone';
  const adfoxInit = adfox[platform].initCode;
  const adfoxIds = adfox[platform].containerIds;

  if (appLocale !== 'ru' || currentPath !== '/games/sea-of-thieves' || bannersDisabled(currentPath)) {
    return null;
  }

  useEffect(() => {
    try {
      if (window.Ya && window.Ya.adfoxCode) {
        adfox.allDevices.initCode();
        adfoxInit();
      }
    } catch (err) {
      console.log('adfox init error', err);
    }
  }, [platform]);

  return [
    ...adfox.allDevices.containerIds.map((id) => <div key={id} className="banner-adfox" id={id} />),
    ...adfoxIds.map((id) => <div key={id} className="banner-adfox" id={id} />),
  ];
};

BannerAdfox.propTypes = propTypes;

export default BannerAdfox;
